/**
 * LF360-2100 — where to go after signing in, when it is not the dashboard.
 *
 * An AI assistant sends the browser to the consent screen, and a user who is
 * not signed in has to sign in first and then come back to that same screen.
 * The login screen always went to the dashboard, and the Google and Microsoft
 * callbacks land on /login whatever happened before, so the address is kept in
 * sessionStorage: it survives those redirects and stays with the tab.
 *
 * Only pages that ask for it are returned to, and only same-origin paths under
 * an allowed prefix: an address in storage must never be a way to send a user
 * somewhere else after they sign in.
 *
 * Read without being removed, because the login screen can land twice for one
 * sign-in (its own handler and the effect that sees the new session); the page
 * returned to clears it.
 */
const KEY = "lf360.returnTo";
const ALLOWED_PREFIXES = ["/oauth/"];

const isAllowed = (path) =>
  typeof path === "string"
  && path.startsWith("/")
  && !path.startsWith("//")
  && !path.includes("\\")
  && ALLOWED_PREFIXES.some((prefix) => path.startsWith(prefix));

export const rememberReturnTo = (path) => {
  try {
    if (isAllowed(path)) sessionStorage.setItem(KEY, path);
  } catch {
    // Storage unavailable: the user lands on the dashboard, as before.
  }
};

export const returnToAfterSignIn = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    return isAllowed(path) ? path : null;
  } catch {
    return null;
  }
};

export const clearReturnTo = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
};
